var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#6D5000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FF930F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99961,
    cy: 7.99961,
    r: 6.4,
    fill: "#FFBB00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5595 9.61949C10.5595 9.96648 10.4713 10.2926 10.295 10.598C10.1257 10.9033 9.87185 11.1601 9.53334 11.3683C9.20188 11.5765 8.80695 11.7014 8.34854 11.743V12.5862H7.66094V11.743C6.99802 11.6806 6.46204 11.4759 6.05301 11.1289C5.64397 10.7819 5.43945 10.3239 5.43945 9.75482H6.73003C6.75119 10.0255 6.83934 10.251 6.99449 10.4314C7.14965 10.6049 7.37179 10.716 7.66094 10.7645V8.47445C7.18843 8.35647 6.80408 8.2385 6.50788 8.12053C6.21168 7.99561 5.9578 7.8013 5.74623 7.53759C5.54171 7.27389 5.43945 6.91303 5.43945 6.45501C5.43945 5.87902 5.64397 5.40365 6.05301 5.02891C6.46204 4.64723 6.99802 4.42516 7.66094 4.3627V3.51953H8.34854V4.3627C8.96915 4.41822 9.46634 4.61253 9.84011 4.94563C10.2209 5.2718 10.436 5.72287 10.4854 6.29887H9.19482C9.17367 6.08374 9.08904 5.89289 8.94094 5.72634C8.79284 5.55285 8.59538 5.43488 8.34854 5.37242V7.62087C8.82105 7.7319 9.2054 7.84988 9.5016 7.97479C9.7978 8.09277 10.0482 8.28361 10.2527 8.54732C10.4572 8.80408 10.5595 9.16148 10.5595 9.61949ZM6.66656 6.39255C6.66656 6.67708 6.75119 6.89915 6.92044 7.05876C7.09675 7.21837 7.34359 7.34675 7.66094 7.44391V5.34119C7.35769 5.37589 7.11438 5.48346 6.93102 5.66389C6.75471 5.84432 6.66656 6.08721 6.66656 6.39255ZM8.34854 10.7645C8.65885 10.716 8.90215 10.5945 9.07846 10.4002C9.25477 10.199 9.34292 9.95954 9.34292 9.68195C9.34292 9.40436 9.25477 9.18923 9.07846 9.03656C8.90921 8.87695 8.6659 8.74857 8.34854 8.65141V10.7645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.16a539282aa6675ed9699c2e355f1f9c.svg";
export { ForwardRef as ReactComponent };